import React from "react";
import { useNavigate } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Landing } from "../components/Landing";
import { LatestPosts } from "../components/LatestPosts";
import { Faq } from "../components/Faq";
import { Footer } from "../components/Footer";

export const Home = () => {
  const navigate = useNavigate();
  return (
    <>
      <Seo
        title="Nexus Numbers Paystub Generator | 1099 & Self-Employed"
        description="Paystub generator for gig, 1099 and self-employed workers. Get professional paystubs now."
        canonicalPath="/"
      />
      <Landing onStart={() => navigate("/create")} />
      <LatestPosts />
      <Faq />
      <Footer />
    </>
  );
};
